import React from 'react';
import PropTypes from 'prop-types';
import { floatString } from "../../util/util";

const Labels = ({
	labelColor,
	labelBottom,
	labelBottomText,
	labelTop,
	labelFontSize,
	valueFontSize,
	appendToValue,
	prependToValue,
	verticalOffset,
	precision,
	hideLabelValue,
	label: labelTopText,
	value,
}) => {
	const styles = {
		labels: {
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			color: `${labelColor}`,
			userSelect: 'none',
			zIndex: 1,
		},

		value: {
			fontSize: `${valueFontSize}`,
			position: 'relative',
		},

		bottomMargin: {
			marginBottom: `calc(${verticalOffset})`,
		},

		appended: {
			position: 'absolute',
			right: '0',
			top: '0',
			transform: 'translate(100%, 0)',
		},

		prepended: {
			position: 'absolute',
			left: '0',
			top: '0',
			transform: 'translate(-100%, 0)',
		},

		hide: {
			display: 'none',
		},
	};

	return (
		<div style={{ ...styles.labels, ...(hideLabelValue && styles.hide) }}>
			{labelTop && <div style={{ fontSize: labelFontSize }}>{labelTopText}</div>}
			<div
				style={{ ...styles.value, ...(!labelBottom && styles.bottomMargin) }}>
				<code>
					<span style={styles.prepended}>{prependToValue}</span>
					{floatString((value / 1000000))}
					<span style={styles.appended}>{appendToValue}</span>
				</code>
			</div>
			{labelBottom && <div style={{ fontSize: labelFontSize }}>{labelBottomText}</div>}
		</div>
	);
};

Labels.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	labelColor: PropTypes.string,
	labelBottom: PropTypes.bool,
	labelBottomTest: PropTypes.string,
	labelTop: PropTypes.bool,
	labelFontSize: PropTypes.string,
	valueFontSize: PropTypes.string,
	appendToValue: PropTypes.string,
	prependToValue: PropTypes.string,
	verticalOffset: PropTypes.string,
	precision: PropTypes.number,
	hideLabelValue: PropTypes.bool,
};

export default Labels;
